import usePageVisibilityChange from '@src/hooks/usePageVisibilityChange';
import { useVideoCreatorStore } from '@src/stores-v2';
import { observer } from 'mobx-react-lite';

const PageVisibilityChangeListener = observer(() => {
  const videoCreator = useVideoCreatorStore();

  usePageVisibilityChange({
    active: [
      // 1. Check if cloudfront links became stale
      videoCreator.refreshManager.handleStoryPopulatedFields,
    ],
  });

  return null;
});

export default PageVisibilityChangeListener;
